import { BaseApi } from 'api/base.api'

// Interface
import {
  IAboutUsStructureApi,
  IAboutUsStructureApiRequest,
  IAboutUsStructureApiGetAttrs,
  IAboutUsStructureApiGetResponse,
  IAboutUsStructureApiSaveAttrs,
  IAboutUsStructureApiSaveResponse,
  IAboutUsStructureApiGetAllAttrs,
  IAboutUsStructureApiGetAllResponse,
} from 'interfaces/back-office/content-management/about-us/structure/about-us-structure-api.interface'
import { IBaseApiRequestPayload } from 'interfaces/api'

// Constant
import { ApiConstant } from 'constant'

// Utils
import { axios_renderUrl } from 'utils'

export class AboutUsStructureApi extends BaseApi<IAboutUsStructureApi> implements IAboutUsStructureApiRequest {
  readonly url = ApiConstant.CONTENT_ABOUT_US_STRUCTURE_URL
  private aboutUsStructureUrl = axios_renderUrl(this.url, ApiConstant.BACK_OFFICE)

  /**
   * @description Get branches
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IAboutUsStructureApiGetAllAttrs} payload
   *
   * @return {Promise<IAboutUsStructureApiGetAllResponse>} Promise<IAboutUsStructureApiGetAllResponse>
   */
  async aboutUsStructure_getAboutUsStructures(
    payload: IAboutUsStructureApiGetAllAttrs,
  ): Promise<IAboutUsStructureApiGetAllResponse> {
    try {
      const response = await this.POST(`${this.aboutUsStructureUrl}/list`, payload.body, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }

  /**
   * @description Get home banner
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IAboutUsStructureApiGetAttrs} payload
   *
   * @return {Promise<IAboutUsStructureApiGetResponse>} Promise<IAboutUsStructureApiGetResponse>
   */
  async aboutUsStructure_getAboutUsStructure(payload: IAboutUsStructureApiGetAttrs): Promise<IAboutUsStructureApiGetResponse> {
    try {
      const response = await this.POST(`${this.aboutUsStructureUrl}/${payload.params.id}`, {}, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }

  /**
   * @description Save home banner
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IAboutUsStructureApiSaveAttrs} payload
   *
   * @return {Promise<IAboutUsStructureApiSaveResponse>} Promise<IAboutUsStructureApiSaveResponse>
   */
  async aboutUsStructure_saveAboutUsStructure(payload: IAboutUsStructureApiSaveAttrs): Promise<IAboutUsStructureApiSaveResponse> {
    try {
      const requestPayload: IBaseApiRequestPayload = {
        method: 'POST',
        url: `${this.aboutUsStructureUrl}/update/${payload.params.id}`,
      }
      const response = await this[requestPayload.method](requestPayload.url, payload.body, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }
}
